import React from "react";
import style from "./MainLayoutStyle";
import Sidebar from "./Sidebar/Sidebar";

export default function MainLayout({ children }) {
  return (
    <div style={style.mainLayoutContainer}>
      {/* <img style={style.backgroundLogo} src="/imgs/logo.png" /> */}
      <div style={style.backgroundGlow}></div>
      <Sidebar />
      <main style={style.contentArea}>{children}</main>
    </div>
  );
}
